import { useEditor } from "@craftjs/core";
import React, { useState, useRef, useEffect, useCallback } from "react";

import { useLayer } from "../useLayer";

export const EditableLayerName = () => {
  const { id } = useLayer();

  const { displayName, actions } = useEditor((state) => ({
    displayName:
      state.nodes[id] && state.nodes[id].data.custom.displayName
        ? state.nodes[id].data.custom.displayName
        : state.nodes[id].data.displayName,
    hidden: state.nodes[id] && state.nodes[id].data.hidden,
  }));

  const [editingName, setEditingName] = useState(false);
  const nameDOM = useRef(null);

  const [internalBlockName, setInternalBlockName] = useState(displayName);

  return (
    <>
      <input
        className="g-editor-toolbar__input bg-transparent outline-none w-full text-ellipsis mr-2 text-grigora-base"
        style={{
          cursor: editingName ? "text" : "default",
          outline: editingName ? "1px solid #000" : "none",
        }}
        readOnly={!editingName}
        onDoubleClick={() => {
          if (!editingName) {
            setInternalBlockName(displayName);
            setEditingName(true);
          }
        }}
        value={editingName ? internalBlockName : displayName}
        onChange={(e) => {
          setInternalBlockName(e.target.value);
        }}
        onKeyDown={(event) => {
          if (event.key === "Enter") {
            actions.setCustom(
              id,
              (custom) => (custom.displayName = internalBlockName),
            );
            setEditingName(false);
          }
        }}
        onBlur={(e) => {
          actions.setCustom(
            id,
            (custom) => (custom.displayName = internalBlockName),
          );
          setEditingName(false);
        }}
      />
      {/* <ContentEditable
      className="editable-layer-name"
      html={displayName}
      disabled={!editingName}
      ref={(ref) => {
        if (ref) {
          nameDOM.current = ref.el.current;
          window.removeEventListener("click", clickOutside);
          window.addEventListener("click", clickOutside);
        }
      }}
      onChange={(e) => {
        actions.setCustom(
          id,
          (custom) => (custom.displayName = e.target.value),
          );
        }}
        tagName="h2"
        onDoubleClick={() => {
          if (!editingName) setEditingName(true);
        }}
        /> */}
    </>
  );
};
